import { createFileRoute } from "@tanstack/react-router";

import { OnboardingCallPage } from "@/features/auth/onboarding/OnboardingCallPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/onboarding-call")({
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Onboarding Call");

  return <OnboardingCallPage />;
}
